export const WEBSITE_URL = (process.env.GATSBY_SITE_URL || 'https://amanita-store.netlify.app').replace(/\/+$/, '');
